/**
 * Animated bird-themed SVG icons (replaces @heroicons/react/24/solid).
 */
import { createBirdHeroicon } from './createIcon';
export const ArchiveBoxIcon = createBirdHeroicon('ArchiveBoxIcon', true);
export const ArrowPathIcon = createBirdHeroicon('ArrowPathIcon', true);
export const BeakerIcon = createBirdHeroicon('BeakerIcon', true);
export const BellIcon = createBirdHeroicon('BellIcon', true);
export const BookmarkIcon = createBirdHeroicon('BookmarkIcon', true);
export const CalendarIcon = createBirdHeroicon('CalendarIcon', true);
export const CheckCircleIcon = createBirdHeroicon('CheckCircleIcon', true);
export const CheckIcon = createBirdHeroicon('CheckIcon', true);
export const ChevronDownIcon = createBirdHeroicon('ChevronDownIcon', true);
export const ChevronUpDownIcon = createBirdHeroicon('ChevronUpDownIcon', true);
export const ChevronUpIcon = createBirdHeroicon('ChevronUpIcon', true);
export const ClipboardDocumentIcon = createBirdHeroicon('ClipboardDocumentIcon', true);
export const ClipboardDocumentListIcon = createBirdHeroicon('ClipboardDocumentListIcon', true);
export const ClockIcon = createBirdHeroicon('ClockIcon', true);
export const CloudArrowUpIcon = createBirdHeroicon('CloudArrowUpIcon', true);
export const CubeIcon = createBirdHeroicon('CubeIcon', true);
export const DocumentDuplicateIcon = createBirdHeroicon('DocumentDuplicateIcon', true);
export const ExclamationTriangleIcon = createBirdHeroicon('ExclamationTriangleIcon', true);
export const EyeIcon = createBirdHeroicon('EyeIcon', true);
export const FunnelIcon = createBirdHeroicon('FunnelIcon', true);
export const HeartIcon = createBirdHeroicon('HeartIcon', true);
export const InformationCircleIcon = createBirdHeroicon('InformationCircleIcon', true);
export const LightBulbIcon = createBirdHeroicon('LightBulbIcon', true);
export const MagnifyingGlassIcon = createBirdHeroicon('MagnifyingGlassIcon', true);
export const PencilIcon = createBirdHeroicon('PencilIcon', true);
export const PhotoIcon = createBirdHeroicon('PhotoIcon', true);
export const PlusIcon = createBirdHeroicon('PlusIcon', true);
export const ShareIcon = createBirdHeroicon('ShareIcon', true);
export const SparklesIcon = createBirdHeroicon('SparklesIcon', true);
export const StarIcon = createBirdHeroicon('StarIcon', true);
export const TagIcon = createBirdHeroicon('TagIcon', true);
export const TrashIcon = createBirdHeroicon('TrashIcon', true);
export const UserGroupIcon = createBirdHeroicon('UserGroupIcon', true);
export const XMarkIcon = createBirdHeroicon('XMarkIcon', true);
